import { getImpersonateTokenFromBe } from './api';

export const isUserCameAsImpersonated = () => {
  const searchParams = new URLSearchParams(window.location.search);

  return searchParams.has('impersonate');
};

const setImpersonateToken = async (id: string) => {
  const token = await getImpersonateTokenFromBe(id);

  if (token) {
    sessionStorage.setItem('impersonate_token', token);

    return token;
  }

  throw new Error("We don't have token");
};

export const activateImpersonateSession = async () => {
  const searchParams = new URLSearchParams(window.location.search);

  await setImpersonateToken(searchParams.get('impersonate') ?? '');
};
